import { useEffect, useRef, useState } from "react";
import BaseInput from "../inputs/BaseInput/BaseInput";
import styles from "./TextField.module.css";

export default function TextField({
  value = "",
  placeholder = "",
  type = "text",
  onChange,
  onCommit,
  disabled = false,
}) {
  const [isEditing, setIsEditing] = useState(false);
  const [draftValue, setDraftValue] = useState(value || "");
  const inputRef = useRef(null);

  useEffect(() => {
    setDraftValue(value || "");
  }, [value]);

  useEffect(() => {
    if (isEditing) {
      queueMicrotask(() => {
        inputRef.current?.focus();
        inputRef.current?.select?.();
      });
    }
  }, [isEditing]);

  const commitValue = () => {
    setIsEditing(false);

    if ((value || "") !== draftValue) {
      onChange?.(draftValue);
      onCommit?.(draftValue);
    }
  };

  const cancelEdit = () => {
    setDraftValue(value || "");
    setIsEditing(false);
  };

  if (isEditing && !disabled) {
    return (
      <BaseInput
        ref={inputRef}
        type={type}
        value={draftValue}
        onChange={setDraftValue}
        onBlur={commitValue}
        onKeyDown={(e) => {
          if (e.key === "Enter") commitValue();
          if (e.key === "Escape") cancelEdit();
        }}
        className={styles.editMode}
      />
    );
  }

  return (
    <button
      type="button"
      className={styles.display}
      onClick={() => {
        if (!disabled) setIsEditing(true);
      }}
      disabled={disabled}
    >
      <span className={value ? styles.value : styles.placeholder}>
        {value || placeholder}
      </span>
    </button>
  );
}
